import * as objectUtils from '@wix/wix-vod-shared/src/common/utils/object';

import getThumbnail from './get-thumbnail';

import channelTypes from '../../../constants/channel-types';
import urlTypes from '../url-types';


export default function parseChannel(urlType, channelData) {

  const {
    id: externalId,
    snippet = {},
    contentDetails = {},
    statistics = {},
    brandingSettings = {},
    isExternalRemoved = false,
  } = channelData;

  const { title, description, thumbnails, publishedAt } = snippet;
  const { itemCount, relatedPlaylists = {} } = contentDetails;
  const videosCount = Number(itemCount || statistics.videoCount) || 0;
  const thumbnailUrl = getThumbnail(thumbnails) || null;

  let coverUrl = _.get(brandingSettings, 'image.bannerTvImageUrl') || thumbnailUrl;
  if (urlType === urlTypes.PLAYLIST && videosCount === 0) {
    coverUrl = null;
  }

  return objectUtils.removeUndefinedValues({
    externalId,
    uploadsPlaylistId: relatedPlaylists.uploads,
    title,
    description,
    thumbnailUrl,
    coverUrl,
    videosCount,
    externalCreatedTs: new Date(publishedAt),
    channelType: channelTypes.YOUTUBE_FEED,
    urlType,
    isExternalRemoved,
  });
}



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/parsers/channel.js